export default __webpack_public_path__ + "static/media/P3.e506bd0c.png";